<template>
  <div
    class="country-selector"
    :class="$blockClass(blockClass, 'country-selector')"
  >
    <p
      :class="$blockClass(blockClass, 'list-header')"
      v-text="$string('general.site_footer.shipping_to')"
    />
    <div
      :class="$blockClass(blockClass, 'list')"
    >
      <btn
        type="button"
        modifiers="text"
        :label="buttonLabel"
        @click="toggleCountrySwitcher"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Country selector (country-selector)
 * -----------------------------------------------------------------------------
 * Dropdown section for site country selector.
 *
 * @param {String} [blockClass] - Block level class to apply to all elements.
 *
 */
import Btn from '~global/btn/btn'
import { mapActions } from 'vuex'

export default {
  name: 'CountrySelector',

  components: {
    Btn,
  },

  props: {
    blockClass: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      country: cnvs.store.countryName,
      currency: cnvs.store.currency,
    }
  },

  computed: {
    buttonLabel() {
      return this.$string('general.site_footer.country_selector_html')
        .replace('{{ site }}', this.country)
        .replaceAll('{{ currency }}', this.currency)
    },
  },

  mounted() {
    this.country = cnvs.store.countryName
    this.currency = cnvs.store.currency
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      toggleOverlay: 'overlays/toggle',
    }),

    /**
     * Toggle country switcher.
     */
    toggleCountrySwitcher() {
      this.toggleOverlay({
        component: 'country-switcher',
        ignoreDismissed: true,
        namespace: 'countrySwitcher',
      })
    },
  },
}
</script>

<style lang="scss">
@import './country-selector';
</style>
